import types from '../mutation-types';
import SocialInboxConfigsAPI from '../../api/socialInboxConfigs';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getConfigs(_state) {
    return _state.records;
  },
  getConfigByInboxId: _state => inboxId => {
    return _state.records.find(c => c.inbox_id === inboxId);
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG, { isFetching: true });
    try {
      const response = await SocialInboxConfigsAPI.get();
      commit(types.SET_SOCIAL_INBOX_CONFIGS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, data) => {
    commit(types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG, { isCreating: true });
    try {
      const response = await SocialInboxConfigsAPI.create({
        social_inbox_config: data,
      });
      commit(types.ADD_SOCIAL_INBOX_CONFIG, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...data }) => {
    commit(types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG, { isUpdating: true });
    try {
      const response = await SocialInboxConfigsAPI.update(id, {
        social_inbox_config: data,
      });
      commit(types.EDIT_SOCIAL_INBOX_CONFIG, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_SOCIAL_INBOX_CONFIGS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_SOCIAL_INBOX_CONFIGS](_state, data) {
    _state.records = data;
  },
  [types.ADD_SOCIAL_INBOX_CONFIG](_state, data) {
    _state.records.push(data);
  },
  [types.EDIT_SOCIAL_INBOX_CONFIG](_state, data) {
    const index = _state.records.findIndex(c => c.id === data.id);
    if (index !== -1) {
      _state.records.splice(index, 1, data);
    }
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
